import React from 'react';
import useSeo from '../hooks/useSeo';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TERMOS = {
  title: 'Termos de Uso',
  updated: '16 de junho de 2026',
  sections: [
    {
      heading: '1. Aceitação dos Termos',
      body: 'Ao acessar ou utilizar a plataforma Nexus, operada pela CarnaúbaHUB, você concorda com estes Termos de Uso. Caso não concorde com qualquer disposição aqui descrita, recomendamos que não utilize a plataforma.',
    },
    {
      heading: '2. Descrição do Serviço',
      body: 'A Nexus é uma plataforma de gestão pública que oferece módulos de controle operacional, requisição do cidadão e gestão de projetos para órgãos e entidades governamentais.',
    },
    {
      heading: '3. Cadastro e Responsabilidades do Usuário',
      body: 'O usuário é responsável por manter a confidencialidade de suas credenciais de acesso e por todas as atividades realizadas em sua conta. Qualquer uso indevido deve ser comunicado imediatamente à nossa equipe.',
    },
    {
      heading: '4. Propriedade Intelectual',
      body: 'Todo o conteúdo, marca, layout e funcionalidades da plataforma Nexus são de propriedade da CarnaúbaHUB e protegidos por leis de propriedade intelectual. É proibida a reprodução sem autorização prévia.',
    },
    {
      heading: '5. Disponibilidade e Manutenção',
      body: 'Empenhamo-nos para manter a plataforma disponível ininterruptamente, mas não garantimos disponibilidade de 100%. Manutenções programadas serão comunicadas com antecedência sempre que possível.',
    },
    {
      heading: '6. Limitação de Responsabilidade',
      body: 'A CarnaúbaHUB não se responsabiliza por danos indiretos decorrentes do uso ou impossibilidade de uso da plataforma, exceto nos casos previstos em lei.',
    },
    {
      heading: '7. Alterações nos Termos',
      body: 'Estes Termos podem ser atualizados periodicamente. Notificaremos os usuários sobre alterações relevantes através do e-mail cadastrado ou de aviso na própria plataforma.',
    },
    {
      heading: '8. Contato',
      body: 'Dúvidas sobre estes Termos podem ser enviadas para gestao@carnaubahub.com.',
    },
  ],
};

const PRIVACIDADE = {
  title: 'Política de Privacidade',
  updated: '16 de junho de 2026',
  sections: [
    {
      heading: '1. Dados Coletados',
      body: 'Coletamos dados fornecidos diretamente por você em formulários do site (nome, e-mail, telefone, mensagem) e dados de uso da plataforma, em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei 13.709/2018).',
    },
    {
      heading: '2. Finalidade do Tratamento',
      body: 'Os dados coletados são utilizados para: responder solicitações de contato e demonstração, prestar o serviço contratado, cumprir obrigações legais e melhorar a experiência na plataforma.',
    },
    {
      heading: '3. Compartilhamento de Dados',
      body: 'Não compartilhamos dados pessoais com terceiros para fins comerciais. Dados podem ser compartilhados com prestadores de serviço estritamente necessários à operação da plataforma (ex.: hospedagem, verificação anti-fraude), sob acordos de confidencialidade.',
    },
    {
      heading: '4. Direitos do Titular',
      body: 'Conforme a LGPD, você tem direito a confirmar a existência de tratamento, acessar, corrigir, anonimizar, eliminar ou solicitar a portabilidade dos seus dados. Solicitações podem ser feitas pelo e-mail gestao@carnaubahub.com.',
    },
    {
      heading: '5. Segurança',
      body: 'Adotamos medidas técnicas e administrativas para proteger os dados pessoais contra acessos não autorizados, perda, alteração ou divulgação indevida.',
    },
    {
      heading: '6. Retenção de Dados',
      body: 'Os dados são mantidos pelo tempo necessário ao cumprimento das finalidades para as quais foram coletados, ou conforme exigido por obrigação legal ou regulatória.',
    },
    {
      heading: '7. Cookies',
      body: 'Utilizamos cookies essenciais ao funcionamento do site e, quando aplicável, cookies analíticos para entender o uso da plataforma e melhorar nossos serviços.',
    },
    {
      heading: '8. Contato do Encarregado (DPO)',
      body: 'Para exercer seus direitos ou esclarecer dúvidas sobre esta política, contate gestao@carnaubahub.com.',
    },
  ],
};

const LegalContent = ({ data }) => (
  <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
    <p className="text-xs font-bold uppercase tracking-widest text-blue-900 mb-3">Documento Legal</p>
    <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 tracking-tight">{data.title}</h1>
    <p className="text-sm text-gray-400 mb-12">Última atualização: {data.updated}</p>

    <div className="space-y-10">
      {data.sections.map((s, i) => (
        <div key={i}>
          <h2 className="text-lg font-bold text-gray-900 mb-2">{s.heading}</h2>
          <p className="text-gray-600 leading-relaxed text-sm">{s.body}</p>
        </div>
      ))}
    </div>
  </div>
);

export const TermosPage = () => {
  useSeo('termos');
  return (
    <>
      <Header />
      <main className="pt-20">
        <LegalContent data={TERMOS} />
      </main>
      <Footer />
    </>
  );
};

export const PrivacidadePage = () => {
  useSeo('privacidade');
  return (
    <>
      <Header />
      <main className="pt-20">
        <LegalContent data={PRIVACIDADE} />
      </main>
      <Footer />
    </>
  );
};
